import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';
import { rotate } from '../layout/keyframes';

export const Spinner = styled.div`
  display: block;
  margin: 0 auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${rotate} 900ms linear infinite;
`;

export const Wrapper = styled.div`
  color: ${theme.colors.loader};
  font-size: ${size(4)};

  &.size-large ${Spinner} {
    width: 2em;
    height: 2em;
    border-width: 6px;
  }

  &.inline {
    display: inline-block;
    vertical-align: middle;
    color: currentColor;
    font-size: inherit;
  }

  &.tone-ghost ${Spinner} {
    border-color: ${theme.colors.button.ghost.default};
    border-top-color: transparent;
  }
`;
